import { styled } from '@material-ui/core';
import { grey } from '@material-ui/core/colors';
import { palettePrimaryMain } from 'src/setup/css-vars';

/**
 * TableCell is the root of the cell and vertically centers the content.
 *
 * Keep these styles a static object: one TableCell is rendered per visible cell of a
 * double-virtualized grid, and a `({ theme }) => ...` style would make JSS attach and remove a
 * dynamic stylesheet per instance while scrolling. The brand color therefore comes from the
 * palettePrimaryMain var that each theme emits (see setup/css-vars.ts).
 */
export const TableCell = styled('div')(
  {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    borderBottom: '1px solid',
    borderBottomColor: grey[200],
    borderLeft: '1px solid',
    borderLeftColor: grey[200],
    background: 'var(--row-background, #fff)',

    '&:focus': {
      outline: '2px auto',
      outlineOffset: -1,
      outlineColor: palettePrimaryMain,
    },
  },
  {
    name: 'TableCell',
  },
);
